import { render, staticRenderFns } from "./myProfile.vue?vue&type=template&id=b7e26ecc&"
import script from "./myProfile.vue?vue&type=script&lang=js&"
export * from "./myProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports